import { useEffect } from 'react';
import { ping } from '~/api';
import { PING_INTERVAL_IN_SECONDS } from '~/constants';
import { useNetworkStatusStore } from '~/stores/networkStateStore';

export const NetworkStatusProvider = ({ children }) => {
  const {
    secondsUntilNextPing,
    isBackendOnline,
    setSecondsUntilNextPing,
    setIsBackendOnline,
    setWasBackendPreviouslyOnline
  } = useNetworkStatusStore();

  useEffect(() => {
    const interval = setInterval(() => {
      ping()
        .then(() => {
          setWasBackendPreviouslyOnline(isBackendOnline);
          setIsBackendOnline(true);
        })
        .catch(() => {
          setWasBackendPreviouslyOnline(isBackendOnline);
          setIsBackendOnline(false);
        });
    }, PING_INTERVAL_IN_SECONDS * 1000);

    return () => clearInterval(interval);
  }, [isBackendOnline]);

  useEffect(() => {
    if (isBackendOnline) {
      setSecondsUntilNextPing(PING_INTERVAL_IN_SECONDS);
      return;
    }

    const interval = setInterval(() => {
      setSecondsUntilNextPing(secondsUntilNextPing <= 1 ? PING_INTERVAL_IN_SECONDS : secondsUntilNextPing - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isBackendOnline, secondsUntilNextPing]);

  return children;
};
